import ConfirmActionDialog from '../../shared/components/patterns/ConfirmActionDialog';

export default function SessionExpiryWarning({ open, onContinue, onLogin, isChecking = false }) {
  return (
    <>
      {open ? <span className="sr-only">La sessione sta per scadere</span> : null}
      <ConfirmActionDialog
        focusTitle
        horizontalActions
        confirmFirst
        open={open}
        title="La sessione sta per scadere"
        description="Per sicurezza verrai disconnesso tra poco. Continua a lavorare per mantenere attiva la sessione oppure esegui il logout."
        confirmLabel="Continua a lavorare"
        cancelLabel="Logout"
        cancelIconKey="actions.logout"
        cancelTone="danger"
        loading={isChecking}
        onConfirm={onContinue}
        onCancel={onLogin}
      />
    </>
  );
}
